import { render, staticRenderFns } from "./childDataList.vue?vue&type=template&id=2a4ce6ed&scoped=true"
import script from "./childDataList.vue?vue&type=script&lang=js"
export * from "./childDataList.vue?vue&type=script&lang=js"
import style0 from "./childDataList.vue?vue&type=style&index=0&id=2a4ce6ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4ce6ed",
  null
  
)

export default component.exports